module.exports = __webpack_public_path__ + "img/rule2.20a8a86d.png";